/* 🤖 this file was generated by svg-to-ts */
export const matIconFormatTextdirectionRToL: {
  name: 'format-textdirection-r-to-l';
  data: string;
} = {
  name: 'format-textdirection-r-to-l',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 4v4c-1.1 0-2-.9-2-2s.9-2 2-2m8-2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4v5h2V4h2v11h2V4h2V2zM8 14l-4 4 4 4v-3h12v-2H8v-3z"/></svg>`
};
